import { Link } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'

function NotFound() {
  return (
    <div className="flex min-h-[60svh] flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-brand text-sm font-semibold">404</p>
      <div className="space-y-1">
        <h1 className="text-foreground text-2xl font-semibold">Page not found</h1>
        <p className="text-muted-foreground max-w-sm text-sm">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
      </div>
      <Button asChild>
        <Link to="/">Back to home</Link>
      </Button>
    </div>
  )
}

export { NotFound }
